import React from 'react';
import type { Partner } from '../../types/partners';
import { PartnerImage } from './PartnerImage';
import { cn } from '../../src/lib/utils';

/** Partner logo at a fixed height; falls back to the partner name if the file is unavailable. */
export function PartnerLogo({
  partner,
  className,
  eager
}: {
  partner: Partner;
  className?: string;
  eager?: boolean;
}) {
  return <PartnerImage asset={partner.logo} eager={eager} className={cn('h-8 w-auto max-w-full object-contain object-left', className)} fallback={<span className={cn('inline-flex h-8 items-center text-xl font-semibold tracking-[-0.02em] text-text-primary', className)} data-id="element-952" data-mp="21e4cng1dd442">
          {partner.name}
        </span>} data-id="element-951" data-mp="2u431babniz87" />;
}